import React, { useEffect, useState } from "react";
import { Card, CardHeader, Collapse, CardContent } from "@mui/material";
import { styled } from "@mui/material/styles";

interface TableData {
  data: any;
}

const MyCardHeader = styled(CardHeader)({
  display: "flex",
  justifyContent: "space-between",
  //alignItems: 'center',
  flexWrap: "wrap",
  "& .MuiCardHeader-content": {
    display: "flex",
  },
  "& .MuiCardHeader-title": {
    flexGrow: 1,
    textAlign: "left",
    fontSize: "17px",
    fontWeight: "500",
    span: {
      width: "50%",
    },
  },
  "& .MuiCardHeader-subheader": {
    textAlign: "right",
    paddingRight: "10px",
    whiteSpace: "nowrap",
  },
  margin: "0",
  padding: "8px 8px 4px",
});

function Table(props: TableData) {
  const renderData = () => {
    if (props.data !== undefined && Object.keys(props.data).length !== 0) {
      return Object.keys(props.data).map((el: any, index: number) => {
        return (
          <div className="cardNotify clickable" key={el} style={{width: "400px"}}>
            <Card
              sx={{
                cursor: "auto",
                width: "100%",
                borderRadius: "0px",
                boxShadow: "none",
                marginBottom: "2px",
                "& .MuiCardHeader-root": {
                  backgroundColor: "rgba(0,0,0, 0.06)",
                  fontSize: "17px",
                },
                "& .MuiCollapse-root": {
                  backgroundColor: "rgba(0,0,0, 0.03)",
                  borderTop: "2px solid white",
                },
                "& .MuiCardContent-root": {
                  padding: "0px",
                },
                "& .MuiCardContent-root:last-child": {
                  padding: "0px",
                },
              }}
            >
              <MyCardHeader title={props.data[el].metadata.display.name} />

              {/* <Collapse in={expanded[index]} timeout="auto" unmountOnExit>
                  <CardContent>
                    <div className="notifications-details-container">
                      <p className="notifications-details-text">{el.data.desc}</p>
                      {Object.keys(el.data.actions).length > 0 ? (
                        <CardActions>
                          {Object.keys(el.data.actions).map((name) => {
                            return (
                              <Button
                                key={el.id + "_" + name}
                                size="small"
                                id={"accept_" + el.id}
                                onClick={() => {
                                  el.do(el.data.actions[name])
                                    .then((val) => {
                                      if (
                                        val !== null &&
                                        val.hasOwnProperty("redirect")
                                      ) {
                                        window.location.href =
                                          serverUrl + val.redirect;
                                        toast.info("Notification action saved!");
                                      } else {
                                        toast.info("Notification action saved!");
                                      }
                                    })
                                    .catch((e) => {
                                      toast.error(
                                        "Unable to save action. \n" + e
                                      );
                                    });
                                }}
                                sx={{ backgroundColor: "white" }}
                              >
                                {name}
                              </Button>
                            );
                          })}
                        </CardActions>
                      ) : (
                        <CardActions>
                          <Button
                            key={el.id}
                            size="small"
                            id={"accept_" + el.id}
                            onClick={() => {
                              el.do("")
                                .then((val) => {
                                  if (val !== "done") {
                                    throw new Error(val);
                                  } else {
                                    toast.info("Notification action saved!");
                                  }
                                })
                                .catch((e) => {
                                  toast.error("Unable to save action. \n" + e);
                                  console.log("Unable to save action. \n" + e);
                                });
                            }}
                            sx={{ backgroundColor: "white" }}
                          >
                            Mark as read
                          </Button>
                        </CardActions>
                      )}
                    </div>
                  </CardContent>
                </Collapse> */}
            </Card>
          </div>
        );
      });
    } else {
      return (
        <div className="messages">
          <p>No existing templates.</p>
        </div>
      );
    }
  };

  return (
    <>
      <div>{renderData()}</div>
    </>
  );
}

export default Table;
